import { omitBy, isNil } from 'lodash';

const ValidationException = (error: any) => {

  if (isNil(error))
    return false;

  const { path, message, type, params } = error;
  let errorMessage: string = '';
  let refPath: string | null = null;

  if (type?.includes('empty') || type?.includes('required')) {
    errorMessage = 'error.required';
  }
  else if (type?.includes('matches') || type?.includes('email')) {
    errorMessage = 'error.pattern';
  }
  else if (type?.includes('min')) {
    errorMessage = 'error.min';
  }
  else if (type?.includes('max')) {
    errorMessage = 'error.max';
  }
  else if (type?.includes('length')) {
    errorMessage = 'error.length';
  }
  else if (type?.includes('only')) {
    errorMessage = 'error.only';
  }
  else if (type?.includes('array.unique')) {
    errorMessage = 'error.unique';
  }
  else if (type?.includes('array.includesRequiredUnknowns')) {
    errorMessage = 'error.oneRequired';
  }
  else if (type?.includes('oneOf') && message?.includes('Ref')) {
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(message);

    refPath = matches ? matches[1] : null;
    errorMessage = 'error.ref';
  }
  else if (type?.includes('oneOf') && message?.includes('acceptTerms')) {
    errorMessage = 'error.acceptTerms';
  }
  else if (message?.includes('At Least One Working Hour')) {
    errorMessage = 'error.atLeastOne';
  }
  else if (type?.includes('compareDate')) {
    errorMessage = 'error.compareDate';
  }
  else if (type?.includes('compareTime')) {
    errorMessage = 'error.compareTime';
  }
  else if (type?.includes('compareValue')) {
    errorMessage = 'error.compareValue';
  }
  else if (type?.includes('is-float')) {
    errorMessage = 'error.isFloat';
  }
  else {
    errorMessage = 'error.validationFailed';
  }

  if (path) {
    return omitBy({ path, refPath, value: errorMessage, message, length: params?.length }, isNil);
  }

  return false;
}

export default ValidationException;
